module.exports = __webpack_public_path__ + "assets/img/block-right-cf5acef0.png";